export default "__VITE_ASSET__Dm2JFMfL__"